/* unplugin-vue-components disabled */import { render } from "./pixelArtList.vue?vue&type=template&id=12e40842&scoped=true"
import script from "./pixelArtList.vue?vue&type=script&lang=js"
export * from "./pixelArtList.vue?vue&type=script&lang=js"

import "./pixelArtList.vue?vue&type=style&index=0&id=12e40842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e40842"]])

export default __exports__